import React from 'react';
import { Success } from 'e4shared';
import { useSelector } from 'react-redux';

import Feedback from 'components/asideRight/components/feedback';
import DebugHelper from 'components/debugHelper';
import Menu from 'components/prism/menu';
import AsideRight from 'components/asideRight';
import { PartnerSpoof } from 'components/header/components/partnerspoof';
import { withRouter } from 'react-router-dom';

export const Prism = ({ history, children, setShowSuccess }) => {
    const { leftAsideOpen, exploreAsideOpen, filterAsideOpen, rightAsideOpen } = useSelector(state => state.ui);
    const [sideStyle, setSideStyle] = React.useState('');

    React.useEffect(() => {
        if (exploreAsideOpen || filterAsideOpen) {
            setSideStyle('wide');
        }

        if (rightAsideOpen) {
            setSideStyle('');
        }
    }, [exploreAsideOpen, filterAsideOpen, rightAsideOpen]);

    return (
        <>
            <Feedback />
            <DebugHelper />
            <Success setShowSuccess={setShowSuccess} />
            {/* Desktop Collapse */}
            <input type="checkbox" id="collapse-toggle" checked={!leftAsideOpen} />

            {/* Mobile Slide-Out */}
            <input type="checkbox" id="mobile-toggle" />

            {/* signout panel */}
            <input type="checkbox" id="signout-toggle" />

            {/* Mobile Hamburger */}
            <label for="mobile-toggle" className="hamburger">
                <i className="fa fa-bars"></i>
            </label>

            <PartnerSpoof history={history} />
            <div className="app">
                {filterAsideOpen && <div className="content-overlay" />}
                {exploreAsideOpen && <div className="explore-open" />}
                <Menu />
                {/* BACKDROP (Mobile) */}
                <label className="backdrop" for="mobile-toggle"></label>

                {/* MAIN CONTENT */}
                <main id="root" className="main">
                    {/* <div className="card">
                        Above you can see 2 header layouts. One for home, the other for any page with a back.
                        <br />
                        <br />
                        This is where the main content goes?
                    </div> */}
                    {children}
                </main>
            </div>
            <AsideRight sideStyle={sideStyle} />
        </>
    );
};

export default withRouter(Prism);
